//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { storageRef } from '../../../../firebase';

//import Components

//import Style classes
import './ExplainCard.css';

class ExplainCard extends Component{
    constructor(props) {
        super(props);

        this.state = {
            url : ''
        }
    }

    componentDidMount() {
        this.loadImageFromStorage();
    }

    loadImageFromStorage = () => {
        this.setState({
            url: ''
        })
        storageRef.child(`introduction_images/${this.props.data.id}.jpg`).getDownloadURL()
            .then((url) => {
                this.setState((prevState) => ({
                    url
                }))
            })
            .catch(e => {
            })
    }

    toggleOpen = () => {
        this.setState({ open : !this.state.open });
    }

    render(){
        const {data, lang, index} = this.props;
        const more = lang === "en" ? "More" : "자세히 보기";

        let classArray = [
            "ExplainCard",
            this.props.black ? "black" : "",
            this.state.open ? "open" : ""
        ]

        let imageBox = 
        <div className="ImageBox">
            <img src={this.state.url} alt=""/>
        </div>

        let textBox = 
        <div className="TextBoxWrapper">
            <div className="TextBox">
                <h3>{data.title[lang]}</h3>
                <p>{data.content[lang]}</p>
            </div>
            {/* <div className="More">
                <p>{more}</p>
            </div> */}
        </div>

        return(
            <div className={classArray.join(' ')} >
                {this.props.right ? textBox : imageBox}
                {this.props.right ? imageBox : textBox}
            </div>
        )
    }
}

export default ExplainCard;

ExplainCard.propTypes = {
    data: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    black: PropTypes.bool.isRequired,
    right: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired
  };



// WEBPACK FOOTER //
// ./src/pages/Home/Introduction/ExplainCard/ExplainCard.js